import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getCategoriesSortingMode } from 'store/AppState/selector'
import { getCategoriesIndexes } from 'store/Categories/selectors'
import { getItemsIndexes } from 'store/Items/selector'
import { updateCategories } from 'store/Categories/actions'
import { updateGlobalItem } from 'store/Items/actions'
import { setCategoriesSortingMode } from 'store/AppState/actions'
import { getFeatureFlags } from 'store/FeatureFlags/selectors'

const ListFilters = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const categoriesSortingMode = useSelector(getCategoriesSortingMode)
  const categoriesIndexes = useSelector(getCategoriesIndexes)
  const itemsIndexes = useSelector(getItemsIndexes)
  const { sortCategoriesBySortOrder } = useSelector(getFeatureFlags)

  const redirectToAddNew = () => history.push('categories/new')

  const handleUpdateCategoriesAndItems = useCallback(() => {
    const categoriesWithCorrectIndexes = categoriesIndexes.map(
      (category, index) => ({ ...category, sortOrder: index })
    )

    const itemsWithCorrectIndexes = itemsIndexes.map(
      (category, index) => ({ ...category, sortOrder: index })
    )

    dispatch(updateCategories(categoriesWithCorrectIndexes))
    dispatch(updateGlobalItem(itemsWithCorrectIndexes))
  }, [dispatch, itemsIndexes, categoriesIndexes])

  const handleCategoriesSortingMode = useCallback(() => {
    dispatch(setCategoriesSortingMode(!categoriesSortingMode))
  }, [dispatch, categoriesSortingMode])

  return (
    <div className="categories-filters">
      {categoriesSortingMode ? (
        <>
          <button
            className="btn sort-categories -save"
            type="button"
            onClick={handleUpdateCategoriesAndItems}
          >
            Save
          </button>
          <button
            className="btn sort-categories"
            type="button"
            onClick={handleCategoriesSortingMode}
          >
            Cancel
          </button>
        </>
      ) : (
        <button
          className="btn sort-categories"
          type="button"
          onClick={handleCategoriesSortingMode}
          disabled={!sortCategoriesBySortOrder}
        >
          Sort
        </button>
      )}
      <button
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default ListFilters
